import { render, staticRenderFns } from "./TasahelUnderReports.vue?vue&type=template&id=75d1a4b6&scoped=true&"
import script from "./TasahelUnderReports.vue?vue&type=script&lang=js&"
export * from "./TasahelUnderReports.vue?vue&type=script&lang=js&"
import style0 from "./TasahelUnderReports.vue?vue&type=style&index=0&id=75d1a4b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d1a4b6",
  null
  
)

export default component.exports